import design from "../assets/design.jpg";
import development from "../assets/development.jpg";
import desktop from "../assets/desktop.jpg";

const WorkCardData = [
  {
    number: "01",
    title: "Web Designs",
    text: "Make your business shine on the web.",
    view: "/project/web-design",
    iconColor: "#3F51B5"
  },

  {
    number: "02",
    title: "Web Developments",
    text: "Experience digital innovation.",
    view: "/project/web-development",
    iconColor: "#3F51B5"
  },

  {
    number: "03",
    title: "System Developments",
    text: "Engineered for excellence.",
    view: "/project/system-development",
    iconColor: "#3F51B5"
  },
];

export default WorkCardData;
